import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=35e532b0&"
import script from "./CardButton.vue?vue&type=script&lang=ts&"
export * from "./CardButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports